<script>
  import { RouterView } from '@/libs/Router';
  import { Spinner, notificationsSetup, notificationsPush, alertsSetup, alertsPush } from '@/components';
  import { user, filters, env } from '@/stores';
  import userChange from '@/routes/helpers/userChange';
  import { subscribe } from '@/helpers/notifications';

  import { get as storageGet } from '@/helpers/storage';


  $: $user, userChange();


  /* Notifications */
  notificationsSetup({
    max: 5,
    duration: 7000,
    top: 74,
    right: 10,
  });


  /* Alerts */
  alertsSetup({
    max: 1,
    duration: 5000,
    top: 14,
    right: 'calc(50% - 170px)',
  });


  /* filtersLoad */
  function filtersLoad() {
    const f = storageGet(':filters:' + $user.id.toString());
    //console.log(f);
    if (f) {
      env.push({ clientsFilterState: f.state });
      filters.push({ 'card': f.card, 'firm': f.firm });
    }
    else {
      env.push({ clientsFilterState: 1 });
      /*filters.push({
        'card': {
          selected: [],
          available: [],
        },
        'firm': {
          selected: [],
          available: [],
        },
      });*/
    }
  }


  /* pushNotification */
  function pushNotification(data) {
    notificationsPush(data.message, 'g-toast-notification');
  }


  /* pushAlert */
  function pushAlert(data) {
    alertsPush(data.message, 'g-warning-alert');
  }


  filtersLoad();


  // subscriptions
  subscribe('notifications', pushNotification);
  subscribe('alerts', pushAlert);
</script>


<style lang="scss">
  @import 'styles/global.scss';

  .spinner-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    background-color: var(--color-bg-dark);
  }

  :global(.g-toast-notification) {
  	--width: 300px;
  	--bg-color: rgb(45, 50, 62);
  	--close-color: rgba(255, 255, 255, .5);
  }

  :global(.g-warning-alert) {
  	--close-color: rgba(255, 255, 255, .5);
  }
</style>


<RouterView>
  <div slot="loading" class="spinner-wrapper">
    <Spinner />
  </div>
</RouterView>
